import { validators } from '../utils';
import { makeFormHook } from '../utils/factory';
import type { InferFormType } from '../utils/types';

export const mcpCompleteAccountFormSchema = validators.object({
  birthday: validators.birthdateAdult(),
  phoneNumber: validators.e164PhoneNumber(),
});

export type MCPCompleteAccountFormSchema = InferFormType<typeof mcpCompleteAccountFormSchema>;

export const mcpCompleteAccountFormDefaultValues = {
  birthday: '' as DateISOString,
  phoneNumber: '',
} satisfies MCPCompleteAccountFormSchema;

export const useMCPCompleteAccountForm = makeFormHook(
  mcpCompleteAccountFormSchema,
  mcpCompleteAccountFormDefaultValues,
);
